"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
require("core-js/modules/web.dom.iterable");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.sort");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _RegionStorePane = _interopRequireDefault(require("../RegionStorePane"));
var _goods_activity_combo = require("@/api/goods_activity/goods_activity_combo");
var _promotion = require("@/api/goods_activity/promotion.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PromotionConfigPane',
  components: {
    RegionStorePane: _RegionStorePane.default
  },
  props: {
    promotionFnId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      categoryCascadeProps: {
        value: 'id',
        multiple: true
      },
      refreshKey: 0,
      rawCheckedCategoryIds: null,
      // 保存后端返回的原始分类数据
      rawExecuteDateList: null,
      // 保存后端返回的原始日期数据
      categoryRootId: 1,
      // 分类根节点ID（后端要求包含在路径中）
      form: {
        activityName: '',
        // 活动名称
        executeDateList: [],
        // 执行日期
        vipMember: true,
        // 资格限制（游客/会员）
        memberLevels: [],
        // 会员等级
        disabledCoupon: true,
        // 是否禁用优惠券
        markForEnable: true,
        // 是否启用
        markAllGoods: false,
        // 是否关联全部商品
        targetScope: '',
        // 使用范围 商品与分类
        checkedCategoryIds: [],
        // 分类数据
        checkedGoodsList: [],
        // 商品数据
        orderType: 'all',
        // 订单类型
        menuTypes: [],
        // 点餐类型
        storeScope: 0,
        // 全部门店
        relatedStoreIdList: [],
        // 门店
        tiersRuleList: [] // 阶梯规则
      },
      threshold: 1,
      // 门槛
      discount: 1,
      // 折扣
      checkedGoods: {},
      // 本次搜索选中的商品
      searchGoodsLoading: false,
      // 商品搜索加载中
      goodsList: [],
      // 商品列表
      goodsTableKey: 0,
      // 商品表格key
      goodsCategoryTree: [],
      // 商品分类树
      regionStoreList: [],
      // 门店
      memberLevelList: [],
      // 会员等级
      orderTypeList: [],
      // 订单类型
      menuTypeList: [] // 点餐类型
    };
  },
  created: function created() {
    this.getOrderType(); // 订单类型
    this.getMenuType(); // 点餐类型
    this.queryRegionStoreList(); // 门店
    this.getMemberLevelList(); // 会员等级
    this.getGoodsCateoryTree(); // 获取商品分类树
    if (this.promotionFnId) {
      this.getPromotionDetail();
    }
  },
  methods: {
    getPromotionDetail: function getPromotionDetail() {
      var _this = this;
      (0, _promotion.queryPromotionDetail)(this.promotionFnId).then(function (res) {
        var data = res.data;
        if (data) {
          _this.form.activityName = data.gaPromotion.activityName || '';
          _this.form.executeDateList = data.executeDateList || [];
          _this.form.vipMember = data.gaPromotion.vipMember !== undefined ? data.gaPromotion.vipMember : true;
          _this.form.memberLevels = data.memberLevels || [];
          _this.form.disabledCoupon = data.gaPromotion.disabledCoupon || true;
          _this.form.markForEnable = data.gaPromotion.markForEnable !== undefined ? data.gaPromotion.markForEnable : true;
          _this.form.markAllGoods = data.markAllGoods || false;
          _this.form.targetScope = data.gaPromotion.targetScope || '';
          _this.form.orderType = data.gaPromotion.orderType || 'all';
          _this.form.menuTypes = data.menuTypes || [];
          _this.form.storeScope = data.gaPromotion.storeScope !== undefined ? data.gaPromotion.storeScope : 0;
          _this.form.relatedStoreIdList = data.relatedStoreIdList || [];
          // 处理阶梯规则：确保每条规则都有 sorts 字段
          var tiersList = data.promotionTiers || [];
          _this.form.tiersRuleList = tiersList.map(function (item, index) {
            return {
              threshold: item.threshold,
              discount: item.discount,
              sorts: item.sorts || index + 1
            };
          });
          _this.form.checkedGoodsList = data.checkedGoodsList || [];

          // 保存原始分类数据，等待树数据加载完成后处理
          _this.rawCheckedCategoryIds = data.checkedCategoryIds || null;
          // 保存原始日期数据，用于编辑时比较是否有变化
          _this.rawExecuteDateList = data.executeDateList || [];
          _this.processCategoryIds();
          _this.refreshKey++;
        }
      });
    },
    submitForm: function submitForm() {
      var _this2 = this;
      // 准备提交数据，包含后端支持的字段
      var submitData = _objectSpread({}, this.form);

      // 后端需要 executeDateList 字段（日期数组格式）
      if (this.form.executeDateList && Array.isArray(this.form.executeDateList) && this.form.executeDateList.length === 2) {
        submitData.executeDateList = this.form.executeDateList;
      }

      // 处理阶梯规则：为每条规则生成唯一标识，规避后端唯一键冲突
      if (submitData.tiersRuleList && Array.isArray(submitData.tiersRuleList)) {
        submitData.tiersRuleList = submitData.tiersRuleList.map(function (item, index) {
          var sorts = item.sort || item.sorts || index + 1;
          return {
            threshold: item.threshold,
            discount: item.discount,
            sorts: sorts
          };
        });
      }

      // 处理分类路径：添加根节点ID（后端期望的格式）
      if (submitData.checkedCategoryIds && Array.isArray(submitData.checkedCategoryIds)) {
        submitData.checkedCategoryIds = submitData.checkedCategoryIds.map(function (path) {
          // 如果路径的第一个元素不是根节点ID，则添加根节点ID
          if (path.length > 0 && path[0] !== _this2.categoryRootId) {
            return [_this2.categoryRootId].concat((0, _toConsumableArray2.default)(path));
          }
          return path;
        });
      }
      if (this.promotionFnId) {
        // 编辑
        var editData = _objectSpread(_objectSpread({}, submitData), {}, {
          fnId: this.promotionFnId
        });
        (0, _promotion.updatePromotion)(editData).then(function (res) {
          _this2.$message.success(res.message);
          _this2.$emit('success');
        });
      } else {
        // 新建
        (0, _promotion.addPromotion)(submitData).then(function (res) {
          _this2.$message.success(res.message);
          _this2.$emit('success');
        });
      }
    },
    removeTiersRule: function removeTiersRule(index) {
      this.form.tiersRuleList.splice(index, 1);
      // 删除后重新排序 sorts 值
      this.reorderTiersSort();
    },
    addTiersRule: function addTiersRule() {
      // 计算新的 sorts 值（当前最大值 + 1）
      var maxSort = this.form.tiersRuleList.length > 0 ? Math.max.apply(Math, (0, _toConsumableArray2.default)(this.form.tiersRuleList.map(function (item) {
        return item.sorts || 0;
      }))) : 0;
      this.form.tiersRuleList.push({
        threshold: this.threshold,
        discount: this.discount,
        sorts: maxSort + 1
      });
    },
    // 重新排序阶梯规则的 sorts 值
    reorderTiersSort: function reorderTiersSort() {
      this.form.tiersRuleList.forEach(function (item, index) {
        item.sorts = index + 1;
      });
    },
    handleRegionStoreChange: function handleRegionStoreChange(val) {
      var _this3 = this;
      // 收集所有区域中的门店ID
      var allStoreIds = [];
      this.regionStoreList.forEach(function (regionStore) {
        var refName = "regionStore_".concat(regionStore.regionId);
        var regionPane = _this3.$refs[refName];
        // regionPane 可能是数组（因为有多个相同ref）或单个对象
        var pane = Array.isArray(regionPane) ? regionPane[0] : regionPane;
        if (pane && typeof pane.getCheckedStoreIds === 'function') {
          allStoreIds.push.apply(allStoreIds, (0, _toConsumableArray2.default)(pane.getCheckedStoreIds()));
        }
      });

      // 去重后赋值
      this.form.relatedStoreIdList = (0, _toConsumableArray2.default)(new Set(allStoreIds));
      console.log('relatedStoreIdList:', this.form.relatedStoreIdList);
    },
    removeGoods: function removeGoods(item) {
      var index = -1;
      for (var i = 0; i < this.form.checkedGoodsList.length; i++) {
        var goods = this.form.checkedGoodsList[i];
        if (item.goodsFnId === goods.goodsFnId) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        this.form.checkedGoodsList.splice(index, 1);
      }
    },
    addGoods: function addGoods() {
      var exist = false;
      if (this.checkedGoods && this.checkedGoods.goodsFnId) {
        for (var i = 0; i < this.form.checkedGoodsList.length; i++) {
          var goods = this.form.checkedGoodsList[i];
          if (this.checkedGoods.goodsFnId === goods.goodsFnId) {
            exist = true;
            break;
          }
        }
        if (!exist) {
          this.form.checkedGoodsList.push(this.checkedGoods);
        }
        this.checkedGoods = {};
      }
    },
    searchGoods: function searchGoods(query) {
      var _this4 = this;
      this.searchGoodsLoading = true;
      (0, _goods_activity_combo.queryGoodsSearch)({
        keywords: query
      }).then(function (res) {
        var data = res.data;
        if (data) {
          _this4.goodsList = data.goodsList || [];
          _this4.searchGoodsLoading = false;
        }
      }, function () {
        _this4.searchGoodsLoading = false;
      });
    },
    getOrderType: function getOrderType() {
      var _this5 = this;
      (0, _goods_activity_combo.queryOrderType)().then(function (res) {
        var data = res.data;
        if (data) {
          _this5.orderTypeList = data.records || [];
        }
      });
    },
    getGoodsCateoryTree: function getGoodsCateoryTree() {
      var _this6 = this;
      (0, _goods_activity_combo.queryGoodsCateoryTree)().then(function (res) {
        var data = res.data;
        if (data) {
          _this6.goodsCategoryTree = data.categoryTree || [];
          // 树数据加载完成后，重新处理分类数据
          _this6.processCategoryIds();
        }
      });
    },
    processCategoryIds: function processCategoryIds() {
      // 处理分类数据：过滤掉树结构中不存在的节点路径
      if (this.rawCheckedCategoryIds && Array.isArray(this.rawCheckedCategoryIds) && this.goodsCategoryTree.length > 0) {
        // 收集树结构中所有的节点ID
        var treeIds = new Set();
        var _collectIds = function collectIds(nodes) {
          nodes.forEach(function (node) {
            treeIds.add(node.id);
            if (node.children && node.children.length > 0) {
              _collectIds(node.children);
            }
          });
        };
        _collectIds(this.goodsCategoryTree);

        // 过滤路径，只保留树结构中存在的节点
        this.form.checkedCategoryIds = this.rawCheckedCategoryIds.map(function (path) {
          return path.filter(function (id) {
            return treeIds.has(id);
          });
        }).filter(function (path) {
          return path.length > 0;
        });
      }
    },
    queryRegionStoreList: function queryRegionStoreList() {
      var _this7 = this;
      (0, _goods_activity_combo.queryRegionStoreList)().then(function (res) {
        var data = res.data;
        if (data) {
          _this7.regionStoreList = data.storeRegions || [];
        }
      });
    },
    getMemberLevelList: function getMemberLevelList() {
      var _this8 = this;
      (0, _goods_activity_combo.queryMemberLevelList)().then(function (res) {
        _this8.memberLevelList = res.data || [];
      });
    },
    getMenuType: function getMenuType() {
      var _this9 = this;
      (0, _goods_activity_combo.queryMenuType)().then(function (res) {
        var data = res.data;
        if (data) {
          _this9.menuTypeList = data.records || [];
        }
      });
    }
  }
};